import { render, staticRenderFns } from "./projectinfo.vue?vue&type=template&id=419bc914&scoped=true"
import script from "./projectinfo.vue?vue&type=script&lang=js"
export * from "./projectinfo.vue?vue&type=script&lang=js"
import style0 from "./projectinfo.vue?vue&type=style&index=0&id=419bc914&prod&lang=scss&scoped=true"
import style1 from "./projectinfo.vue?vue&type=style&index=1&id=419bc914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419bc914",
  null
  
)

export default component.exports